// ** Redux Imports
import {
  createSlice,
  //  createAsyncThunk
} from "@reduxjs/toolkit";
import { logFilter } from "@logging";

// import defaultSearchSuggestions from "./defaultSearchSuggestions";

const TAG = "navbar";
// ** Axios Imports
// import axios from 'axios'

// export const getBookmarks = createAsyncThunk(
//   "layout/getBookmarks",
//   async () => {
//     const response = await axios.get("/api/bookmarks/data");
//     return {
//       data: response.data.suggestions,
//       bookmarks: response.data.bookmarks,
//     };
//   }
// );

// export const updateBookmarked = createAsyncThunk(
//   "layout/updateBookmarked",
//   async (id) => {
//     await axios.post("/api/bookmarks/update", { id });
//     return id;
//   }
// );

export const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    query: "",
    bookmarks: [],
    // suggestions: defaultSearchSuggestions(),
  },
  reducers: {
    handleSearchQuery: (state, action) => {
      // logFilter('search', action.payload)
      state.query = action.payload;
    },
    handleSuggestionOptions: (state, action) => {
      logFilter(TAG, "handleSuggestionOptions", action.payload);
      state.suggestions = action.payload;
    },
    handleAddPageToSearchOptions: (state, action) => {
      logFilter(TAG, "handleAddPageToSearchOptions", action);
      // state.suggestions = action.payload
      let existingIndex = -1;
      const newSuggestions = state.suggestions.map((entry, index) => {
        logFilter(TAG, "handleAddPageToSearchOptions", index);
        if (entry.groupTitle === "Active Pages") {
          logFilter(
            TAG,
            "handleAddPageToSearchOptions",
            "filtering on groupTitle",
            entry.data.length,
          );
          existingIndex = entry.data.findIndex(
            (e) => e.id === action.payload.id,
          );
          logFilter(
            TAG,
            "handleAddPageToSearchOptoins",
            "existingIndex is",
            existingIndex,
          );
          if (existingIndex === -1) {
            // not found, let's add it
            logFilter(
              TAG,
              "handleAddPageToSearchOptions",
              "not found, we can add/insert",
            );
            const groupReplacement = {
              groupTitle: "Active Pages",
              searchLimit: 10,
              data: entry.data.concat(action.payload),
            };
            logFilter(
              TAG,
              "handleAddPageToSearchOptions",
              "replace with",
              groupReplacement,
            );
            return groupReplacement;
          } else {
            // we already have this id, just let it ride (or replace it?)
            logFilter(
              TAG,
              "handleAddPageToSearchOptions",
              "already found, just chill",
            );
            return entry;
          }
        } else {
          return entry;
        }
      });
      state.suggestions = newSuggestions;
      // logFilter('store', 'handleAddPageToSearchOptions', action, state)
      // const blah = {...state.suggestions}
      // logFilter('store', 'handleAddPageToSearchOptions', 'here is the copy', blah)
      // const existingIndex = state.suggestions.findIndex(entry => {
      //   logFilter('store', 'findIndex', entry)
      //   return entry.id === action.payload.id
      // })
      // logFilter('store', 'handleAddPageToSearchOptions', 'existingIndex', existingIndex)
      // const ret = state.suggestions.map((entry, index) => {
      //   logFilter('store', 'iterating throuh existing entries', entry, index)
      //   return entry
      // })
      // return ret
    },
  },
  extraReducers: (builder) => {
    logFilter(TAG, "do nothing with ", builder);
    // builder
    //   .addCase(getBookmarks.fulfilled, (state, action) => {
    //     logFilter("store", "getBookmarks");
    //     state.bookmarks = action.payload.bookmarks;
    //   })
    //   .addCase(updateBookmarked.fulfilled, (state, action) => {
    //     let objectToUpdate;
    //     logFilter("store", "updateBookmarked addCase");
    //     // ** find & update object
    //     state.suggestions.find((item) => {
    //       if (item.id === action.payload) {
    //         item.isBookmarked = !item.isBookmarked;
    //         objectToUpdate = item;
    //       }
    //     });

    //     // ** Get index to add or remove bookmark from array
    //     const bookmarkIndex = state.bookmarks.findIndex(
    //       (x) => x.id === action.payload
    //     );

    //     if (bookmarkIndex === -1) {
    //       state.bookmarks.push(objectToUpdate);
    //     } else {
    //       state.bookmarks.splice(bookmarkIndex, 1);
    //     }
    //   });
  },
});

export const {
  handleSearchQuery,
  handleSuggestionOptions,
  handleAddPageToSearchOptions,
  handlePatchSuggestionsWithBookmarks,
} = layoutSlice.actions;

export default layoutSlice.reducer;
